import { render, staticRenderFns } from "./After.vue?vue&type=template&id=aa4138c0&scoped=true"
import script from "./After.vue?vue&type=script&lang=js"
export * from "./After.vue?vue&type=script&lang=js"
import style0 from "./After.vue?vue&type=style&index=0&id=aa4138c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4138c0",
  null
  
)

export default component.exports